
import colorStyles from '../../assets/styles/variables/export-colors.scss';
import { includesValidator } from '../../common/utils/validator';

function adjustColor(color, amount) {
  const value = color && color
    .replace(/^#/, '')
    .replace(/../g, (el) => `0${Math.min(255, Math.max(0, parseInt(el, 16) + amount)).toString(16)}`
      .slice(-2));
  return `#${value || '000000'}`;
}

const lightColors = [
  'bb-neutral-0',
  'bb-neutral-4',
  'bb-neutral-5',
  'bb-neutral-6',
  'bb-interface-2',
  'bb-interface-4',
  'bb-interface-8',
  'bb-interface-9',
  'bb-interface-10',
  'bb-interface-11',
  'bb-interface-12',
];

const ButtonTypes = {
  Primary: 'primary',
  Secondary: 'secondary',
  Tretiary: 'tretiary',
  Quaternary: 'quaternary',
  Quinary: 'quinary',
  Senary: 'senary',
};

const ButtonSizes = {
  Large: 'large',
  Medium: 'medium',
  Small: 'small',
};

export default {
  name: 'BbBtn',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: ButtonTypes.Primary,
      validator: includesValidator(ButtonTypes),
    },
    size: {
      type: String,
      default: ButtonSizes.Large,
      validator: includesValidator(ButtonSizes),
    },
    isIconButton: {
      type: Boolean,
      default: false,
    },
    withoutBackground: {
      type: Boolean,
      default: false,
    },
    withShadow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: String,
    iconType: String,
    color: {
      type: String,
      default: undefined,
      validator: (value) => value === undefined || Object.keys(colorStyles).includes(value),
    },
  },
  computed: {
    buttonStyleVariables() {
      return {
        ...(this.color ? {
          '--button-color': colorStyles[this.color],
          '--button-color-darken': adjustColor(colorStyles[this.color], -30),
        } : {}),
        ...(lightColors.includes(this.color) ? {
          '--light-style-background': colorStyles['bb-neutral-1'],
          '--light-style-text-color': colorStyles['bb-neutral-1'],
        } : {}),
      };
    },
  },
};
